// extracted by mini-css-extract-plugin
export default {"page":"Ingredients_page__L+ZRt"};